import { render } from "./UnassignedPatientVisits.vue?vue&type=template&id=643ee7ef&ts=true"
import script from "./UnassignedPatientVisits.ts?vue&type=script&lang=ts&external"
export * from "./UnassignedPatientVisits.ts?vue&type=script&lang=ts&external"

import "./UnassignedPatientVisits.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__